module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-2800.b38609df.svg";